import styled from 'styled-components';

import { contentHeight } from './variables';
import { gridColumn } from 'styleUtils/grid';
import { toMedium } from 'styleUtils/mediaQueries';

export const MapsRouter = styled.div`
    position: relative;
    text-align: right;
    height: ${contentHeight};
    width: 100%;
    //Google maps water color
    background-color: #aadaff;
    ${gridColumn({ start: 2 })}

    ${toMedium`
        ${gridColumn({ start: 1 })}
    `};
`;
